import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

import { CsvSeparator } from '../file-export/file-export.service';

@Injectable({ providedIn: 'root' })
export class FileImportService {
  async readSheet(
    file: File,
    separator: CsvSeparator = ',',
    opts: {cellDates?: boolean; sheetIndex?: number} = {},
  ): Promise<string[][]> {
    const cellDates = opts.cellDates ?? false;
    const sheetIndex = opts.sheetIndex ?? 0;
    const buffer = await file.arrayBuffer();
    const wb = XLSX.read(buffer, { type: 'array', FS: separator, cellDates });
    return XLSX.utils.sheet_to_json<string[]>(wb.Sheets[wb.SheetNames[sheetIndex]], {
      header: 1,
      defval: '',
    });
  }

  async getSheetNames(file: File): Promise<string[]> {
    const buffer: ArrayBuffer = await file.arrayBuffer();
    const workbook: XLSX.WorkBook = XLSX.read(buffer, { type: 'array' });
    return workbook.SheetNames;
  }
}
